import appConfig from '@nerdwallet/app-config';
// eslint-disable-next-line lodash/import-scope
import pick from 'lodash/pick';
// eslint-disable-next-line lodash/import-scope
import get from 'lodash/get';
import { setAuthenticatedStatus } from '../containers/authentication/authentication-reducer';
import { getHeaders } from './helpers';
import nwApiSDK from './nw-api-sdk';

const { httpClient } = nwApiSDK;

export const loadIdentity = async (opts) => {
  const { store, req } = opts;
  const lpcReferer = get(req, 'headers.referer');
  const forwardedHeaders = req.headers
    ? {
        'X-External-Referer': lpcReferer,
        ...getHeaders(req, [
          'X-Caller-Client-ID',
          'X-Header-CSRF-Token',
          'X-Pageview-ID',
          'X-Originating-URL',
          'X-Originating-Referrer',
          'X-Originating-User-Agent',
          'X-Cookie-ID',
          'X-Browser-Session-ID',
          'X-Request-ID',
        ]),
      }
    : {};

  const baseUrl = appConfig.NERDWALLET_BASE_URL;
  const url = `${baseUrl}/api/identity/api/v1/identities/me`;
  const getCookie = (cookieName) => pick(req.cookies, cookieName);

  try {
    const args = {
      method: 'GET',
      url,
      cookies: {
        // get necessary cookies for authentication in the server
        ...getCookie('nw_session_token'),
        ...getCookie('csrf_token'),
      },
      serverRequest: req,

      headers: {
        'cache-control': 'nocache',
        ...forwardedHeaders,
      },
    };
    const { body } = await httpClient.fetch(args);
    return store.dispatch(
      setAuthenticatedStatus({
        id: body?.data?.identity?.id,
        roles: body?.data?.identity?.roles,
      })
    );
  } catch (error) {
    return null;
  }
};
